import React, { FC } from 'react';
import styles from './DescriptiveHighlightTile.module.scss';
import { Text as ScText } from '@sitecore-jss/sitecore-jss-react';
import { Field, ImageField, NextImage } from '@sitecore-jss/sitecore-jss-nextjs';

export type DescriptiveHighlightTileFields = {
  icon: ImageField;
  title: Field<string>;
  description: Field<string>;
};

type Props = {
  fields: DescriptiveHighlightTileFields;
  numberOfItems: number;
};

const DescriptiveHighlightTile: FC<Props> = ({ fields, numberOfItems }) => {
  const numberClass = `layout-${numberOfItems}`;

  return (
    <div className={`background-to-change p-2 ${numberClass}`}>
      <div className={styles.descriptiveHighlightTitle}>
        <NextImage
          field={fields.icon}
          className={`background-to-change ${styles.descriptiveHighlightIcon} flex-shrink-0 me-2`}
          width={48}
          height={48}
        />
        <ScText tag="h6" field={fields.title} className="text-grey" />
      </div>
      <ScText
        tag="p"
        field={fields.description}
        className={`${styles.descriptiveHighlightContent} body-default text-grey mt-1`}
      />
    </div>
  );
};

export default DescriptiveHighlightTile;
